import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { returnInputFieldLength } from "../../utils/commonFunctions";
type finalFileDataType = {
  file_name: string;
  id: any;
};

type AppProps = {
  handleRenameFile: (data: any) => void;
  isOpen: boolean;
  toggleRenameFileModal: () => void;
  currentFile: any;
};

const RenameFileModal = ({
  handleRenameFile,
  isOpen,
  toggleRenameFileModal,
  currentFile,
}: AppProps) => {
  let fileExtension = currentFile?.file_name?.split(".");
  let finanlFileExtension = fileExtension[fileExtension?.length - 1];
  let preFilledInputData = fileExtension
    .slice(0, fileExtension?.length - 1)
    .join(".");
  const [fileName, setFileName] = useState<string>(preFilledInputData);
  const [fileNameError, setFileNameError] = useState<string>("");
  const [onCancel, setOnCancel] = useState(isOpen);

  const handleFileNameChange = (e: any) => {
    setFileName(e.target.value);

    if (fileNameError) {
      setFileNameError("");
    }
  };

  const handleAddFileName = (e: any) => {
    e.preventDefault();
    if (!fileName.trim().length) {
      setFileNameError("File name is required!");
    } else {
      let finalData: finalFileDataType = {
        file_name: fileName.trim() + `.${finanlFileExtension}`,
        id: currentFile?.id,
      };

      handleRenameFile(finalData);
    }
  };

  return (
    <Modal isOpen={onCancel} toggle={() => setOnCancel(true)}>
      <ModalHeader className="pt-4 pl-4">Rename File</ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <div className="row"></div>
        <form>
          <div className="form-group mt-3">
            <div>
              <label
                htmlFor="filername"
                className={currentFile ? "active" : ""}
              >
                Enter File Name (Please do not add file extension)
                <span className="color-red">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  !!fileNameError ? "error-border" : null
                }`}
                name="text"
                value={fileName}
                autoFocus
                onChange={(e) => handleFileNameChange(e)}
                maxLength={60}
                onKeyPress={(e: any) =>
                  e.key === "Enter" ? handleAddFileName(e) : null
                }
              />
              {!!fileNameError && (
                <small className="text-danger">{fileNameError}</small>
              )}
            </div>
            <span className="input-length">
              {returnInputFieldLength(fileName?.length, 60)}
            </span>
            <div className="mt-3">
              <input
                type="text"
                className={`form-control`}
                name="text"
                value={finanlFileExtension}
                disabled
              />
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <span
          className="pointer"
          onClick={() => {
            setOnCancel(!onCancel);
            toggleRenameFileModal();
          }}
        >
          Cancel
        </span>
        <Button color="primary ml-3" onClick={(e: any) => handleAddFileName(e)}>
          {" "}
          Rename File
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default RenameFileModal;
